import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background">
      <div className="text-center space-y-6">
        <div className="text-9xl font-bold text-primary">404</div>
        <h1 className="text-4xl font-bold">Page non trouvée</h1>
        <p className="text-muted-foreground text-lg max-w-md">
          Désolé, la page que tu cherches n'existe pas ou a été déplacée.
        </p>
        <Button size="lg" onClick={() => navigate("/")} className="gap-2">
          <Home className="w-4 h-4" />
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
}
